package com.ricky.realtimeledger

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import com.ricky.realtimeledger.utils.LocalBreakpoint
import com.varabyte.kobweb.compose.css.ScrollBehavior
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.minHeight
import com.varabyte.kobweb.compose.ui.modifiers.scrollBehavior
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.loadFromLocalStorage
import com.varabyte.kobweb.silk.theme.colors.systemPreference
import kotlinx.browser.document
import org.jetbrains.compose.web.css.vh
import kotlin.time.Duration.Companion.milliseconds
import androidx.compose.runtime.*

private const val COLOR_MODE_KEY = "realtimeledger:colorMode"

@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.loadFromLocalStorage(COLOR_MODE_KEY) ?: ColorMode.systemPreference

    ctx.stylesheet.registerStyleBase("html") {
        Modifier.styleModifier {
            property("color-scheme", "light")
        }
    }

    ctx.stylesheet.registerStyleBase("html") {
        Modifier.scrollBehavior(ScrollBehavior.Smooth)
    }
}


@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    SilkApp {
        // Track the screen size globally
        val breakpoint = rememberBreakpoint()

        LaunchedEffect(Unit) {
            kotlinx.coroutines.delay(300.milliseconds)
            document.documentElement?.classList?.remove("preloader-active")
        }

        // Provide the breakpoint to the entire app!
        CompositionLocalProvider(LocalBreakpoint provides breakpoint) {
            Surface(
                SmoothColorStyle.toModifier().minHeight(100.vh).fillMaxWidth()
            ) {
                content()
            }
        }
    }
}
